module.exports = __webpack_public_path__ + "img/individuelles_eheringe.4df136f6.jpg";